import { Box, Divider, styled, Typography, useTheme } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useAppSelector } from 'src/app/hooks';
import { useTranslation } from 'react-i18next';

interface DateRangeLabelProps {
  label: string;
}

const FooterBox = styled(Box)(
  ({ theme }) => `
    width: 100%;
    margin-top: ${theme.spacing(2)};
    display: flex;
    align-items: center;
  `
);

const DateRangeLabel: React.FC<DateRangeLabelProps> = ({ label }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dateRangeOptionActive = useAppSelector(
    (state) => state.analyticArguments.dateRangeOptionActive
  );

  const dateRangeLabel = () => {
    if (dateRangeOptionActive.id !== 'custom') {
      return t(dateRangeOptionActive.label.toLowerCase());
    }
    return `${moment(dateRangeOptionActive.start).format('L HH:mm')} - ${moment(
      dateRangeOptionActive.end
    ).format('L HH:mm')}`;
  };
  return (
    <FooterBox>
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 600,
          flexGrow: 'inherit',
          textTransform: 'lowercase',
          minWidth: 200
        }}
      >
        {label}
        <span
          style={{
            color: theme.palette.primary.main,
            marginLeft: theme.spacing(1)
          }}
        >
          {dateRangeLabel()}
        </span>
      </Typography>
      <Divider
        sx={{
          gridArea: 'divider',
          flexGrow: 1,
          ml: theme.spacing(1),
          display: { xs: 'none', sm: 'block' }
        }}
      />
    </FooterBox>
  );
};

export default DateRangeLabel;
